export enum DragDropMode {
  BASIC,
  AUTO,
}
